import React, { useState, useEffect } from "react";

const ScrollReveal = ({ children }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      });
    });

    observer.observe(document.querySelector(".scroll-reveal"));

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <div
    className="scroll-reveal"
    style={{
      opacity: isVisible ? 1 : 0,
      transform: isVisible ? "translateY(0)" : "translateY(100%)",
      transition: "transform 1s ease-in-out , opacity 2s ease-in-out",
    }}
    >
      {children}
    </div>
  );
};

export default ScrollReveal;